export const FEISHU_EXCHANGE_TIMEOUT_MS = 10_000;

export function abortError(): DOMException {
  return new DOMException('Authentication attempt invalidated', 'AbortError');
}

/** End the page's wait even when an adapter does not settle after abort. */
export function withAbortTimeout<T>(
  operation: Promise<T>,
  controller: AbortController,
  timeoutMs = FEISHU_EXCHANGE_TIMEOUT_MS,
  onTimeout?: () => void,
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    if (controller.signal.aborted) {
      reject(abortError());
      return;
    }
    let settled = false;
    const finish = (callback: () => void) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeout);
      controller.signal.removeEventListener('abort', onAbort);
      callback();
    };
    const onAbort = () => finish(() => reject(abortError()));
    const timeout = window.setTimeout(() => finish(() => {
      onTimeout?.();
      controller.abort();
      reject(new Error('自动登录超时'));
    }), timeoutMs);
    controller.signal.addEventListener('abort', onAbort, { once: true });
    operation.then(value => finish(() => resolve(value)), error => finish(() => reject(error)));
  });
}
